import { forwardRef, type HTMLAttributes } from 'react';
import cn from 'classnames';

import { H1 } from '@/components/Typography/Typography';

import css from './styles.module.scss';

interface SplitTitleProps extends HTMLAttributes<HTMLHeadingElement> {
  text: string;
}

const SplitTitle = forwardRef<HTMLHeadingElement, SplitTitleProps>(
  ({ text, ...props }, ref) => {
    return (
      <H1 ref={ref} {...props} className={cn(css.splitTitle, props.className)}>
        {text}
      </H1>
    );
  },
);

export { SplitTitle };
